module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-7.57a381b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-7.png
// module id = R5WV
// module chunks = 34